import React from 'react';
import stlukeLogo from '../../../assets/Img/stluke-donation-logo.png';

const DonationHeader: React.FC = () => {
  return (
    <>
      {/* Navigation Header */}
      <header className="w-full bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={stlukeLogo} alt="St. Luke Community Healthcare" className="h-20 w-auto" />
          </div>
          <a
            href="#donate-form"
            className="bg-[#71001F] text-white text-sm font-semibold px-5 py-2 rounded-lg hover:bg-[#5a0018] transition-colors"
          >
            Give Now
          </a>
        </div>
      </header>

      {/* Hero Campaign Section */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-6 py-12 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
            In 1955, it was $1 a month.<br />
            Today, it's $12. The mission is the same.
          </h1>
          <p className="text-gray-600 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
            In 1955, when Dr. Charles Thornton opened his office in Ronan, he asked the community
            to pledge just $1 a month to help secure essential equipment and furnishings. It was
            simple. It was accessible. And it worked.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
            Neighbors stepped forward. Among them was "Old Doc Brooke," who gave $10 a month —
            a leadership gift that set the tone for what community commitment could look like.
          </p>
          <p className="text-gray-500 text-sm italic">
            The numbers have changed. The spirit has not.
          </p>

          {/* Campaign Badge */}
          <div className="mt-10 pt-8 border-t border-gray-200">
            <h2 className="text-xl font-bold text-[#71001F] mb-2">The $1 Legacy Campaign</h2>
            <p className="text-gray-600 text-sm max-w-xl mx-auto">
              We are honoring that original 1955 pledge with a modern giving opportunity designed for today's
              community — accessible, transparent, and meaningful at every level.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DonationHeader;
